import { createSelector } from '@reduxjs/toolkit'
import { selectUnitPrices } from '../slices/unitPrices.slice'

export const selectRawMaterialOptions = createSelector(
  [selectUnitPrices],
  unitPrices => {
    return Array.from(new Set(
      unitPrices
        .map(u => u.rawMaterial)
        .filter(Boolean),
    ))
  },
)